import React, { useState } from "react";
import { Button, Tooltip, Popconfirm, Modal, Select, message } from "antd";
import { CheckCircleOutlined, StopOutlined } from "@ant-design/icons";

const ActionColumn = ({ record, onSchedule, onBlock, daysList = 365 }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedDay, setSelectedDay] = useState(null);
  const generateDaysList = () => {
    const initial = [5, 10, 15, 20, 25, 30];
    const rest = [];
    for (let i = 60; i <= 360; i += 30) {
      rest.push(i);
    }
    return [...initial, ...rest, 365];
  };
  const list = daysList && daysList.length ? daysList : generateDaysList();

  const handleSubmit = () => {
    if (!selectedDay) {
      message.warning("Please select a day!");
      return;
    }
    if (onSchedule) {
      onSchedule(record, selectedDay);
    }
    message.success(`Demo scheduled for ${selectedDay} days`);
    setIsModalOpen(false);
    setSelectedDay(null);
  };

  const handleBlock = () => {
    if (onBlock) {
      onBlock(record);
    }
    message.error(`Company "${record.company_name}" has been blocked`);
  };

  return (
    <>
      {/* First Action - Schedule trial */}
      <Tooltip title="Schedule trial">
        <Button
          type="primary"
          size="small"
          style={{ marginRight: "10px" }}
          icon={<CheckCircleOutlined />}
          onClick={() => setIsModalOpen(true)}
        />
      </Tooltip>

      {/* Second Action - Bypass */}
      <Popconfirm
        title="Free trial Bypass"
        description={`Are you sure you want to Bypass "${record.company_name}" for free trial?`}
        onConfirm={handleBlock}
        okText="Yes"
        cancelText="No"
      >
        <Tooltip title="Free trial Bypass">
          <Button type="primary" size="small" danger icon={<StopOutlined />} />
        </Tooltip>
      </Popconfirm>

      {/* Modal for Select Days */}
      <Modal
        title="Select trial period for this company"
        open={isModalOpen}
        onOk={handleSubmit}
        onCancel={() => setIsModalOpen(false)}
        okText="Submit"
        cancelText="Cancel"
      >
        <Select
          placeholder="Select duration"
          style={{ width: "100%" }}
          value={selectedDay}
          onChange={(val) => setSelectedDay(val)}
        >
          {list?.map((day) => (
            <Select.Option key={day} value={day}>
              {day} {day === 1 ? "Day" : "Days"}
            </Select.Option>
          ))}
        </Select>
      </Modal>
    </>
  );
};

export default ActionColumn;
